<script>
import { layoutComputed } from "@/state/helpers";
import CKEditor from "@ckeditor/ckeditor5-vue";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ClassicEditor from "ckeditor5-build-classic-with-font";
import Swal from "sweetalert2";
import api from "../../api";
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import Switches from "vue-switches";

export default {
  props: ["page", "schema", "formData", "submitted"],
  components: {
    ckeditor: CKEditor.component,
    Switches,
  },
  data() {
    return {
      fileCategory: "",
      editorData: "",
      tempDepSelectedValue: null,
      fileName: null,
      fileSelectedFlag: false,
      formDataSlug: this.formData.slug,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "fontColor",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "insertTable",
          "undo",
          "redo",
        ],
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1",
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3",
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4",
            },
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        fontColor: {
          colors: [
            {
              color: "#005EB8",
              label: "Blue",
            },
            {
              color: "#FF2E2E",
              label: "Red",
            },
            {
              color: "#4F535B",
              label: "Main Grey",
            },
          ],
        },
        link: {
          decorators: {
            toggleDownloadable: {
              mode: "manual",
              label: "Downloadable",
              attributes: {
                download: "file",
              },
            },
            openInNewTab: {
              mode: "manual",
              label: "Open in a new tab",
              attributes: {
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
          },
        },
      },
      // editorConfig: {
      //   removePlugins: [ 'ImageUpload', 'Iframe', 'Insert', 'MediaEmbed' ]

      //     // plugins: Base64UploadAdapter,
      //   // heading: {
      //   //     options: [
      //   //         { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      //   //         { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      //   //         { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      //   //         { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
      //   //         { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
      //   //         { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
      //   //         { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
      //   //     ]
      //   // }
      // }
    };
  },
  computed: {
    ...layoutComputed,
    depSelectedValue: {
      get: function () {
        if (this.tempDepSelectedValue) {
          return this.tempDepSelectedValue;
        } else {
          var val = "Selected";
          if (this.formData["image_url"] !== undefined) {
            if (this.formData["image_url"].length > 0) {
              val = "Image";
            }
          }
          if (this.formData["video_url"] !== undefined) {
            if (this.formData["video_url"].length > 0) {
              val = "Video";
            }
          }
          return val;
        }
      },
      set: function (newValue) {
        this.tempDepSelectedValue = newValue;
        // return newValue;
      },
    },
    //   depSelectedValue: {
    //   // getter
    //   get: function () {
    //     var val = null;
    //     if(this.formData['image_url'] !== undefined) {
    //       if(this.formData['image_url'].length > 0) {
    //         val = 'Image';
    //       }
    //     }
    //     if(this.formData['video_url'] !== undefined) {
    //       if(this.formData['video_url'].length > 0) {
    //         val = 'Video';
    //       }
    //     }
    //     return val;
    //     // return this.formData['image_url'] !== undefined && this.formData['image_url'].length() > 0 ? 'Image' : this.formData['video_url'] !== undefined && this.formData['video_url'].length() > 0 ? 'Video' : null;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     return newValue;
    //   }
    // }
  },
  watch: {
    formData: {
      // deep: true,
      // if(this.formData['slug'])
      handler() {
        this.tempDepSelectedValue = null;
        // console.log('Formdata has changed!')
      },
    },
  },
  mounted() {
    console.log("====> mounted");
  },
  methods: {
    submitForm() {
      this.$emit("form-submitted", true);
    },
    updateCategory(val) {
      this.page.fileCat = val;
    },
    updateName(val) {
      console.log(val);
      this.fileName = val;
      this.page.fileName = val;
      // var a = this.page.fileSelected;
      // a.files.item(0).name = val;
      // this.page.fileSelected = null;
      // this.page.fileSelected = a;
      // console.log(a)
    },
    // watch: {
    //   page: {
    //     deep: true,
    updateTable() {
      // if(this.page.formData.role)
      // {
      this.page.table.rows = this.page.schema.role.options.filter(
        (e) => e.id == this.page.formData.role
      )[0].permissions;
      this.page.formData.permissions = this.page.schema.role.options.filter(
        (e) => e.id == this.page.formData.role
      )[0].permissions;
      // }
      // delete this.page.table.rows.timestamp
      // delete this.page.formData.permissions.timestamp
    },
    //   },
    // },
    checkSlugAvailability() {
      let where = {
        name: {
          like: this.formData.slug,
          options: "i",
        },
        // "cmsId": "string",
      };
      var url = "/slugs/count?where=" + JSON.stringify(where);
      api.get(url).then(
        (response) => {
          if (response.data.count > 0) {
            var newSlug = this.formData.slug + "-1";
            if (this.formData.slug.includes("-")) {
              var lastChars = Number(this.formData.slug.split("-").pop());
              if (typeof lastChars == "number") {
                newSlug = this.formData.slug.split("-")[0] + "-" + ++lastChars;
              }
            }
            Object.assign(this.formData, { slug: newSlug });
            this.checkSlugAvailability();
            // Swal.fire("Slug Not Available!", "Please enter slug again.", "warning");
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    onImageSelect() {
      console.log("file upload");

      const selectedFiles = document.getElementById("uploadmyfile").files;

      // Check if multiple files are selected
      if (selectedFiles.length > 1) {
        this.fileSelectedFlag = false;
        return;
      }

      // Validate file size
      if (selectedFiles.length === 1) {
        const file = selectedFiles[0];
        const maxSize = 3 * 1024 * 1024; // 3 MB in bytes

        // Check if file size exceeds the limit
        if (file.size > maxSize) {
          this.fileSelectedFlag = false;
          Swal.fire(
            "File Size Error!",
            "The file you are trying to upload exceeds the maximum allowed size of 3 MB. Please reduce the file size and try again.",
            "warning"
          );
          return;
        }

        // If all validations pass
        this.page.fileSelected = selectedFiles; // Assign the selected file
        this.fileSelectedFlag = true;
      } else {
        this.fileSelectedFlag = false;
      }
    },

    onImageSelect2() {
      // console.log('file', document.getElementById('uploadmyfile2').files.item(0));
      this.page.fileSelected = document
        .getElementById("uploadmyfile2")
        .files.item(0);
      this.fileSelectedFlag = true;
    },
    onImageSelect3() {
      console.log(
        "file",
        document.getElementById("uploadmyfile3").files.item(0)
      );
      this.page.fileSelected = document
        .getElementById("uploadmyfile3")
        .files.item(0);
      this.fileName = this.page.fileSelected.name;
      this.fileSelectedFlag = true;
      console.log(this.page.fileSelected);
    },
    dropFile(e) {
      this.page.fileSelected = e.dataTransfer.files[0];
      this.fileName = this.page.fileSelected.name;
      this.fileSelectedFlag = true;

      // console.log(this.page.fileSelected);
      // if(!droppedFiles) return;
      // // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      // ([...droppedFiles]).forEach(f => {
      //   this.files.push(f);
      // });
    },
    depSelected(e) {
      this.depSelectedValue = e.target.value;
    },
    removeFile() {
      console.log("11");
      delete this.page.fileSelected;
      this.fileSelectedFlag = false;
      this.fileName = null;
    },
  },
};
</script>

<template>
  <form class="needs-validation w-100">
    <div class="row">
      <div
        v-for="(item, key) in schema"
        :key="key"
        :class="item.wrapper_class ? item.wrapper_class : 'col-md-12'"
      >
        <div class="form-group">
          <div
            v-if="item.type == 'seperator'"
            class="w-100 my-4"
            style="border-bottom: 1px solid #dadce3"
          ></div>
          <div v-if="item.label" class="d-flex">
            <label
              class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
              :class="
                item.type == 'heading'
                  ? 'font-size-30'
                  : '' || item.type == 'paragraph'
                  ? 'font-weight-normal'
                  : ''
              "
              :for="key + _uid"
              >{{ item.label }}<span v-if="item.required"> *</span></label
            >
            <img
              :id="key + _uid"
              variant="primary"
              class="align-self-center"
              src="@/assets/images/info.svg"
              alt=""
            />
            <!-- <i :id="key + _uid" variant="primary" class="ri-information-fill my-auto font-size-18 font-gray-color"></i> -->
            <b-tooltip :target="key + _uid">{{
              item.tooltip ? item.tooltip : "Enter " + item.label
            }}</b-tooltip>
            <p
              v-if="item.character_count > 0"
              class="font-size-14 mb-2 font-weight-medium text-muted ml-auto align-self-sm-center"
            >
              Character Count: {{ formData[key] ? formData[key].length : 0 }} /
              {{ item.character_count }}
            </p>
            <div
              v-if="item.label == 'Practices'"
              class="form-check ml-auto align-self-center"
            >
              <input class="form-check-input" type="checkbox" />
              <label class="form-check-label ml-1">Select All</label>
            </div>
          </div>
          <div
            v-if="item.label == 'Practices'"
            style="border-bottom: 1px solid #dadce3"
            class="mb-3"
          ></div>

          <div
            v-if="
              item.type == 'file' && page.title !== 'Member Practices' && page
                ? page.title
                : false
            "
          >
            <input
              id="uploadmyfile"
              type="file"
              ref="file"
              hidden
              class=""
              accept=".pdf,.docx,.doc,.pptx,.ppt,.png,.jpg,.jpeg"
              v-on:change="onImageSelect(this)"
            />
            <div
              v-show="!fileSelectedFlag"
              class="p-4"
              style="
                text-align: center;
                border: 1px dashed #cad2dc;
                background: #eff7fb;
              "
              v-cloak
              @drop.prevent="dropFile"
              @dragover.prevent
            >
              <i class="ri-5x ri-file-upload-fill"></i>
              <p class="font-size-16">
                Drag and drop files here or {{ page.title }}
                <a
                  href="#"
                  v-on:click="$el.querySelector('#uploadmyfile').click()"
                  style="text-decoration: underline !important"
                  >click to browse</a
                >
                your computer. Acceptable file formats are PDF, DOCX, XLS, or
                PPTX format. The individual file size should not exceed 3MB.
              </p>
            </div>
            <div
              v-show="fileSelectedFlag"
              class="p-4"
              style="text-align: center"
            >
              <i class="ri-5x ri-file-upload-fill"></i>
              <p class="font-size-16 mb-5">
                Click Save to upload and return to the main page
              </p>
              <input
                class="form-control mb-3"
                type="search"
                name=""
                id=""
                placeholder="Enter filname if you want to change or click Save."
                :value="
                  page.fileSelected && page.fileSelected.length == 1
                    ? page.fileSelected[0].name
                    : ''
                "
                v-on:keyup="updateName($event.target.value)"
              />
            </div>
          </div>

          <div v-if="item.type == 'patientvoice' && page ? page.title : false">
            <input
              id="uploadmyfile"
              type="file"
              ref="file"
              hidden
              class=""
              accept=".pdf,.docx,.doc,.pptx,.ppt,.png,.jpg,.jpeg"
              v-on:change="onImageSelect(this)"
            />
            <div
              v-show="!fileSelectedFlag"
              class="p-4"
              style="
                text-align: center;
                border: 1px dashed #cad2dc;
                background: #eff7fb;
              "
              v-cloak
              @drop.prevent="dropFile"
              @dragover.prevent
            >
              <i class="ri-5x ri-file-upload-fill"></i>
              <p class="font-size-16">
                Drag and drop files here or {{ page.title }}
                <a
                  href="#"
                  v-on:click="$el.querySelector('#uploadmyfile').click()"
                  style="text-decoration: underline !important"
                  >click to browse</a
                >
                your computer. Acceptable file formats are PDF, DOCX, XLS, or
                PPTX format. The individual file size should not exceed 3MB.
              </p>
            </div>
            <div
              v-show="fileSelectedFlag"
              class="p-4"
              style="text-align: center"
            >
              <i class="ri-5x ri-file-upload-fill"></i>
              <p class="font-size-16 mb-5">
                Click Save to upload and return to the main page
              </p>
              <input
                class="form-control mb-3"
                type="search"
                name=""
                id=""
                placeholder="Enter filname if you want to change or click Save."
                :value="
                  page.fileSelected && page.fileSelected.length == 1
                    ? page.fileSelected[0].name
                    : ''
                "
                v-on:keyup="updateName($event.target.value)"
              />
            </div>
          </div>

          <!-- <div v-else-if="item.type == 'file'" class="custom-file col-6">
            <input :id="key + _uid" type="file" class="custom-file-input" />
            <label class="custom-file-label" :for="key + _uid">Choose file</label>
          </div> -->
          <ckeditor
            v-else-if="item.type == 'ckeditor'"
            v-model="formData[key]"
            :editor="editor"
            :config="editorConfig"
            :id="key + _uid"
          ></ckeditor>

          <div
            v-else-if="
              item.type == 'checkbox' && item.label == 'Days / Availability'
            "
            class="row mb-2"
          >
            <div
              class="d-flex col-12"
              v-for="option in item.options"
              :key="option.day"
            >
              <div class="col-6 form-check mb-3">
                <input
                  class="form-check-input my-3"
                  type="checkbox"
                  :value="option"
                  :id="key + option + _uid"
                />
                <label
                  class="form-check-label form-control ml-1 text-capitalize"
                  :for="key + option + _uid"
                  >{{ option.day }}</label
                >
              </div>
              <div class="col-6">
                <select class="form-control">
                  <option>Select</option>
                  <option value="Morning">Morning</option>
                  <option value="Afternoon">Afternoon</option>
                  <option value="All Day">All Day</option>
                </select>
              </div>
            </div>
          </div>
          <div
            v-else-if="item.type == 'checkbox' && item.label == 'Practices'"
            class="row pl-3"
          >
            <div
              v-for="option in item.options"
              v-bind:key="option"
              class="form-check col-12 pb-2"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="formData[key][option]"
                :value="formData[key][option]"
                :id="option + _uid"
              />
              <label class="form-check-label ml-1" :for="option + _uid">{{
                option
              }}</label>
            </div>
          </div>
          <div v-else-if="item.type == 'checkbox'" class="row pl-3">
            <div
              v-for="option in item.options"
              v-bind:key="option"
              class="form-check col-12"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="formData[key][option]"
                :value="formData[key][option]"
                :id="option + _uid"
              />
              <label class="form-check-label ml-1" :for="option + _uid">{{
                option
              }}</label>
            </div>
          </div>
          <div v-else-if="item.type == 'radio'" class="row container">
            <div
              v-for="option in item.options"
              v-bind:key="option"
              class="form-check mr-4"
            >
              <input
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                :id="option + _uid"
                v-model="formData[key][option]"
                :checked="formData[key][option] == true"
              />
              <label class="form-check-label" :for="option + _uid">{{
                option
              }}</label>
            </div>
          </div>
          <div v-else-if="item.type == 'button'">
            <!-- <span class="font-weight-medium mb-0">Add New: </span> -->
            <!-- <i v-b-modal.modal-center class="ri-add-circle-fill text-primary align-self-center font-size-50 ml-2"></i> -->
            <!-- <img v-b-modal.modal-center class="align-self-center ml-2"
            src="@/assets/images/addbtn.svg" alt=""> -->
            <input
              v-b-modal.modal-centers
              :type="item.type"
              value="Change Permissions"
              class="btn btn-primary"
            />
            <!-- <button v-b-modal.modal-centers class="btn btn-primary">Change Permissions</button> -->
            <b-modal
              id="modal-centers"
              size="xl"
              title="Permission Table"
              title-class="font-18"
              hide-footer
            >
              <div v-if="page.table" class="table-responsive">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th
                        class="text-capitalize"
                        v-for="cols in page.table.tableCols"
                        v-bind:key="cols.key"
                      >
                        {{ cols.key }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(value, rkey) in formData.permissions"
                      v-bind:key="rkey"
                    >
                      <td
                        v-for="cols in page.table.tableCols"
                        v-bind:key="cols.key"
                      >
                        <div v-if="cols.type == 'checkbox'" style="width: 20px">
                          <input
                            v-model="formData[key][rkey][cols.key]"
                            :type="cols.type"
                            class="form-control"
                          />
                        </div>
                        <span v-else>{{
                          (v = cols.key == "name" ? rkey : value[cols.key])
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-button
                v-on:click="$bvModal.hide('modal-centers')"
                class="float-right"
                variant="primary"
                >Continue</b-button
              >
            </b-modal>
          </div>
          <div v-else-if="item.type == 'toggle'">
            <div>
              <switches
                v-model="formData[key]"
                type-bold="false"
                color="info"
                class="mt-2"
              ></switches>
            </div>
          </div>
          <div v-else-if="item.type == 'select'">
            <select
              v-if="item.label == 'Role'"
              class="form-control"
              v-model="formData[key]"
            >
              <option
                v-for="option in item.options"
                v-bind:key="option.id"
                :selected="formData[key] == option.id"
                :value="option.id"
              >
                {{ option.title }}
              </option>
            </select>
            <select
              v-if="item.label == 'PCN'"
              class="form-control"
              v-model="formData[key]"
            >
              <option
                v-for="option in item.options"
                v-bind:key="option.id"
                :selected="formData[key] == option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
            <!-- <select v-else class="form-control" v-model="formData[key]">
              <option v-for="option in item.options" v-bind:key="option"
              :selected="formData[key] == option">{{option}}</option>
            </select> -->
          </div>
          <div v-else-if="item.type == 'dep-select'" class="d-flex">
            <select
              class="form-select form-control col-6"
              v-model="depSelectedValue"
            >
              <option
                :selected="depSelectedValue == 'Selected' ? true : false"
                value="Selected"
              >
                Select
              </option>
              <option
                :selected="depSelectedValue == 'Image' ? true : false"
                value="Image"
              >
                Image
              </option>
              <option
                :selected="depSelectedValue == 'Video' ? true : false"
                value="Video"
              >
                Video
              </option>
              <!-- <option v-for="option in item.options" v-bind:key="option"
              :selected="formData['image_url'] ? true">{{option}}</option> -->
            </select>

            <div
              v-if="depSelectedValue == 'Image'"
              class="custom-file col-6 ml-3"
            >
              <input
                id="uploadmyfile3"
                type="file"
                ref="file"
                hidden
                class=""
                v-on:change="onImageSelect3(this)"
              />
              <span
                v-b-modal.modal-center-image
                class="btn btn-light"
                style="background-color: #f0f2f5; border: 1px solid #dadce3"
                >Upload Image</span
              >
              <span v-if="fileName" class="col-3 align-middle"
                >{{ fileName }}
                <i
                  @click="removeFile"
                  class="ri-close-circle-fill font-size-16 align-middle ml-1 text-muted"
                ></i>
              </span>
              <!-- <span v-else-if="formData['image_url']" class="col-3 align-middle">... {{formData['image_url'].slice(-20)}}
                <i @click="removeFile" class="ri-close-circle-fill font-size-16 align-middle ml-1 text-muted"></i>
              </span> -->
              <!-- <img v-b-modal.modal-center-image class="align-self-center ml-2"
              src="@/assets/images/addbtngreen.svg" alt=""> -->
              <b-modal
                ref="modalImage"
                style="letter-spacing: 2em"
                id="modal-center-image"
                centered
                title="Upload Image"
                title-class="font-18"
                hide-footer
              >
                <!-- <input id="uploadmyfile" type="file" ref="file" hidden class="" 
              v-on:change="onImageSelect(this)" /> -->
                <div
                  v-show="!fileSelectedFlag"
                  class="p-4"
                  style="
                    text-align: center;
                    border: 1px dashed #cad2dc;
                    background: #eff7fb;
                  "
                  v-cloak
                  @drop.prevent="dropFile"
                  @dragover.prevent
                >
                  <i class="ri-5x ri-file-upload-fill"></i>
                  <p class="font-size-16">
                    Drag and drop files here or
                    <a
                      href="#"
                      v-on:click="$el.querySelector('#uploadmyfile3').click()"
                      style="text-decoration: underline !important"
                      >click to browse</a
                    >
                    your computer. Acceptable file formats are PDF, DOCX, XLS,
                    or PPTX format. The individual file size should not exceed
                    3MB.
                  </p>
                </div>
                <div
                  v-show="fileSelectedFlag"
                  class="p-4"
                  style="text-align: center"
                >
                  <i class="ri-5x ri-file-upload-fill"></i>
                  <p class="font-size-16 mb-5">
                    Click Save to upload and return to the main page
                  </p>
                  <input
                    class="form-control"
                    type="search"
                    name=""
                    id=""
                    v-model="fileName"
                  />
                </div>
                <b-button
                  @click="$bvModal.hide('modal-center-image')"
                  class="mt-3 float-right"
                  variant="primary"
                  >Save</b-button
                >
              </b-modal>
            </div>
            <div v-if="depSelectedValue == 'Video'" class="col-6 ml-3">
              <input
                :id="key + _uid"
                v-model="formData['video_url']"
                :max="item.character_count == 0 ? 10000 : item.character_count"
                :maxlength="
                  item.character_count == 0 ? 10000 : item.character_count
                "
                :type="item.type"
                class="form-control"
                :placeholder="item.children.video.placeholder"
              />
            </div>
            <!-- {{item.children[formData[key].toLowerCase()]}} -->
          </div>
          <div v-else-if="item.type == 'file-image'" class="custom-file">
            <input
              id="uploadmyfile3"
              type="file"
              ref="file"
              hidden
              class=""
              v-on:change="onImageSelect3(this)"
            />
            <span
              v-b-modal.modal-center-image
              class="btn btn-light"
              style="background-color: #f0f2f5; border: 1px solid #dadce3"
              >Upload Image</span
            >
            <span v-if="fileName" class="col-3 align-middle"
              >{{ fileName }}
              <i
                @click="removeFile"
                class="ri-close-circle-fill font-size-16 align-middle ml-1 text-muted"
              ></i>
            </span>
            <!-- <span v-else-if="formData['image_url']" class="col-3 align-middle">... {{formData['image_url'].slice(-20)}}
                <i @click="removeFile" class="ri-close-circle-fill font-size-16 align-middle ml-1 text-muted"></i>
              </span> -->
            <!-- <img v-b-modal.modal-center-image class="align-self-center ml-2"
              src="@/assets/images/addbtngreen.svg" alt=""> -->
            <b-modal
              ref="modalImage"
              style="letter-spacing: 2em"
              id="modal-center-image"
              centered
              title="Upload Image"
              title-class="font-18"
              hide-footer
            >
              <!-- <input id="uploadmyfile" type="file" ref="file" hidden class="" 
              v-on:change="onImageSelect(this)" /> -->
              <div
                v-show="!fileSelectedFlag"
                class="p-4"
                style="
                  text-align: center;
                  border: 1px dashed #cad2dc;
                  background: #eff7fb;
                "
                v-cloak
                @drop.prevent="dropFile"
                @dragover.prevent
              >
                <i class="ri-5x ri-file-upload-fill"></i>
                <p class="font-size-16">
                  Drag and drop files here or
                  <a
                    href="#"
                    v-on:click="$el.querySelector('#uploadmyfile3').click()"
                    style="text-decoration: underline !important"
                    >click to browse</a
                  >
                  your computer. Acceptable file formats are PDF, DOCX, XLS, or
                  PPTX format. The individual file size should not exceed 3MB.
                </p>
              </div>
              <div
                v-show="fileSelectedFlag"
                class="p-4"
                style="text-align: center"
              >
                <i class="ri-5x ri-file-upload-fill"></i>
                <p class="font-size-16 mb-5">
                  Click Save to upload and return to the main page
                </p>
                <input
                  class="form-control"
                  type="search"
                  name=""
                  id=""
                  v-model="fileName"
                />
              </div>
              <b-button
                @click="$bvModal.hide('modal-center-image')"
                class="mt-3 float-right"
                variant="primary"
                >Save</b-button
              >
            </b-modal>
          </div>
          <div v-else-if="item.type == 'color'">
            <div
              class="d-flex bg-white"
              style="border: 1px solid #ced4da; border-radius: 4px"
            >
              <div style="border-radius: 5px; overflow: hidden; width: 40px">
                <input
                  :id="key + _uid"
                  v-model="formData[key]"
                  :max="
                    item.character_count == 0 ? 10000 : item.character_count
                  "
                  :maxlength="
                    item.character_count == 0 ? 10000 : item.character_count
                  "
                  :type="item.type"
                  class="form-control p-0 border-0"
                  style="
                    width: 200%;
                    height: 200%;
                    transform: translate(-25%, -25%);
                  "
                  :placeholder="item.placeholder"
                />
              </div>
              <div class="pl-3 p-2" style="color: #949ca8">
                {{ formData[key] ? formData[key] : "#000000" }}
              </div>
            </div>
          </div>
          <div
            v-else-if="
              item.type == 'text' ||
              item.type == 'date' ||
              item.type == 'number' ||
              item.type == 'email' ||
              item.type == 'password'
            "
          >
            <div class="d-flex" v-if="item.label == 'Slug'">
              <input
                :id="key + _uid"
                v-model="formData[key]"
                :max="item.character_count == 0 ? 10000 : item.character_count"
                :maxlength="
                  item.character_count == 0 ? 10000 : item.character_count
                "
                :type="item.type"
                class="form-control"
                :placeholder="item.placeholder"
                v-on:blur.prevent="checkSlugAvailability"
                :disabled="item.disabled"
              />
            </div>
            <div class="d-flex" v-else-if="item.label == 'Path'">
              <input
                :id="key + _uid"
                v-model="formData[key]"
                :max="item.character_count == 0 ? 10000 : item.character_count"
                :maxlength="
                  item.character_count == 0 ? 10000 : item.character_count
                "
                :type="item.type"
                class="form-control"
                :placeholder="item.placeholder"
                v-on:blur.prevent="checkSlugAvailability"
                :disabled="item.disabled"
              />
            </div>
            <div v-else>
              <input
                :id="key + _uid"
                v-model="formData[key]"
                :max="item.character_count == 0 ? 10000 : item.character_count"
                :maxlength="
                  item.character_count == 0 ? 10000 : item.character_count
                "
                :type="item.type"
                class="form-control"
                :placeholder="item.placeholder"
              />
            </div>
          </div>
          <b-form-group v-else-if="item.type == 'time'">
            <b-form-input
              id="time"
              v-model="formData[key]"
              type="time"
            ></b-form-input>
          </b-form-group>
          <a
            v-if="item.label == 'Slug' || item.label == 'Path'"
            :href="
              'https://' +
              currentPractice.additionalProp1.url +
              '/' +
              (page.title == 'News' ? 'patientnews' : 'page') +
              '/' +
              formData[key]
            "
            target="_blank"
          >
            <p
              class="ml-auto my-2 font-size-14 font-weight-medium align-self-sm-center"
            >
              {{ currentPractice.additionalProp1.url }}/{{
                page.title == "News" ? "patientnews" : "page"
              }}/{{ formData[key] }}
            </p>
          </a>
          <!-- <a v-else :href="currentPractice.additionalProp1.url+'/'+formData[key]" target="_blank"></a> -->

          <!-- <p v-else-if="item.label == 'Path'" class="ml-auto text-muted my-2 font-size-14 font-weight-medium align-self-sm-center">{{currentPractice.additionalProp1.url}}/{{formData[key]}}</p> -->
        </div>
      </div>
    </div>
  </form>
</template>
<style scoped>
.ck-button__label {
  font-family: "Montserrat";
}
input[type="date"]::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  display: block;
  background: url(../../assets/images/calendar.svg) no-repeat;
  width: 20px;
  height: 20px;
  border-width: thin;
}
</style>
